<template>
  <div class="container" id="facilityVillageWrapper">
    <h2 class="learn-more__slider-header">It’s important we have the correct information about your village</h2>
    <p class="edm__slider-description mt-2">
      Please take the time to answer the following few questions.
    </p>
    <h3 class="learn-more__slider-header fs-20 mt-6 color-very-dark-grayish-blue">What types of homes does your village offer?</h3>
    <p class="fs-13 font-weight-600 font-italic ml-auto mr-auto lh1-3 color-very-dark-grayish-blue mt2" style="max-width: 550px">
      The ‘starting from' price is not displayed on Village Guide's website. This price is used to ensure your village appears under the correct filtered options.
    </p>
    <Form
      :validation-schema="validationSchema"
      v-slot="{ errors }"
      @submit="onSubmit"
      id="facilityVillageForm"
      class="mr-auto ml-auto mt-8"
      style="max-width: 540px;"
    >
      <slot name="token"></slot>
      <div class="slider-form slider-form--care-home slider-form--facility w-100 text-left" style="height: auto">
        <div v-for="(option) in typeOfHomeOptions">
          <hr class="hr-iron mt-4 mb-4">
          <div class="radio-container radio-container--type radio-container--facility">
            <div class="radio-container radio-container--type radio-container--facility">
              <div class="radio-group pt-2 pb-2" :class="{ 'radio-group--active': isCheckboxChecked(option.value, 'typeOfHomes') }">
<!--                <Field v-slot="{ field }" name="typeOfHomes" type="checkbox" :value="true" multiple>-->
                  <Field
                    type="checkbox"
                    class="checkbox"
                    :id="option.name"
                    name="typeOfHomes"
                    v-bind="field"
                    :value="option.value"
                    :data-option-name="option.name"
                    v-model="typeOfHomes"
                  />
                  <label :for="option.name" :class="{ 'active': isCheckboxChecked(option.value, 'typeOfHomes') }">
                    <i class="icon-tick" :class="{ 'icon-tick--active': isCheckboxChecked(option.value, 'typeOfHomes') }"></i>
                    <span v-html="option.value"></span>
                  </label>
<!--                </Field>-->
              </div>
            </div>
          </div>
          <div class="mt-4" v-if="isCheckboxChecked(option.value, 'typeOfHomes')" v-cloak>
            <div class="form-group form-group--input d-flex flex-row mb-4" v-if="option.value === 'Other'">
              <label for="type_of_home_custom" class="sr-only">Type of home:</label>
              <input id="type_of_home_custom" type="text" class="form-control form-control--bg-white fs-15 ph-14" name="type_of_home_custom" placeholder="Type of home">
            </div>
            <div class="form-group form-group--input d-flex flex-row">
              <label :for="`${option.name}_price`" class="d-flex align-items-center mb-0 mr-2 fs-13 color-very-dark-grayish-blue font-weight-bold" style="width: 130px">Starting from:</label>
              <Field
                :id="`${option.name}_price`"
                placeholder="$"
                @input="rewritePriceValue(option.name)"
                v-model="price[option.name]"
                class="form-control form-control--bg-white"
                :class="{'is-danger': errors[`${option.name}_price`] }"
                type="text"
                :name="`${option.name}_price`"
              />
            </div>
            <ErrorMessage :name="`${option.name}_price`" class="is-danger" as="span">
              This field is required
            </ErrorMessage>

            <ul class="form-group text-left mt-6">
              <li class="filter__item checkbox-custom checkbox-custom--inline checkbox-custom--medium mr-4">
                <input type="checkbox" :id="`${option.name}_bedroom_studio`" :name="`${option.name}_bedroom[]`" value="Studio">
                <label :for="`${option.name}_bedroom_studio`" class="form-check-label fs-14 color-very-dark-grayish-blue font-weight-bold">Studio</label>
              </li>
              <li class="filter__item checkbox-custom checkbox-custom--inline checkbox-custom--medium mr-4">
                <input type="checkbox" :id="`${option.name}_bedroom_1`" :name="`${option.name}_bedroom[]`" value="1 bedroom">
                <label :for="`${option.name}_bedroom_1`" class="form-check-label fs-14 color-very-dark-grayish-blue font-weight-bold">1 bedroom</label>
              </li>
              <li class="filter__item checkbox-custom checkbox-custom--inline checkbox-custom--medium mr-4">
                <input type="checkbox" :id="`${option.name}_bedroom_2`" :name="`${option.name}_bedroom[]`" value="2 bedroom">
                <label :for="`${option.name}_bedroom_2`" class="form-check-label fs-14 color-very-dark-grayish-blue font-weight-bold">2 bedroom</label>
              </li>
              <li class="filter__item checkbox-custom checkbox-custom--inline checkbox-custom--medium mr-0">
                <input type="checkbox" :id="`${option.name}_bedroom_3`" :name="`${option.name}_bedroom[]`" value="3 bedroom">
                <label :for="`${option.name}_bedroom_3`" class="form-check-label fs-14 color-very-dark-grayish-blue font-weight-bold">3 bedroom</label>
              </li>
            </ul>
          </div>
        </div>
        <ErrorMessage name="typeOfHomes" class="is-danger" as="span">
          This field is required
        </ErrorMessage>
        <hr class="hr-iron mt-4 mb-4">
        <ul class="form-group mt-6 text-left">
          <label class="form-label-radio mb-5">What is the entry age at your village?</label>
          <li class="radio-custom radio-custom--inline radio-custom--white mr-8">
            <Field type="radio" id="age_55" name="age" value="55+" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="age_55">55+</label>
          </li>
          <li class="radio-custom radio-custom--inline radio-custom--white mr-8">
            <Field type="radio" id="age_60" name="age" value="60+" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="age_60">60+</label>
          </li>
          <li class="radio-custom radio-custom--inline radio-custom--white mr-8">
            <Field type="radio" id="age_65" name="age" value="65+" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="age_65">65+</label>
          </li>
          <li class="radio-custom radio-custom--inline radio-custom--white mr-8">
            <Field type="radio" id="age_70" name="age" value="70+" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="age_70">70+</label>
          </li>
          <li class="radio-custom radio-custom--inline radio-custom--white">
            <Field type="radio" id="age_75" name="age" value="75+" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="age_75">75+</label>
          </li>
        </ul>
        <ErrorMessage name="age" class="is-danger" as="span">
          This field is required
        </ErrorMessage>
        <hr class="hr-iron mt-4 mb-4">
        <ul class="form-group mt-6 text-left">
          <label class="form-label-radio mb-5">Is your village complete?</label>
          <li class="radio-custom radio-custom--white">
            <Field type="radio" id="village_complete_yes" name="villageComplete" value="Yes, no future development planned" @change="showVillageCompleteOther = false" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="village_complete_yes">
              Yes, no future development planned
            </label>
          </li>
          <li class="radio-custom radio-custom--white">
            <Field type="radio" id="village_complete_building" name="villageComplete" value="We are building or have plans for new homes" @change="showVillageCompleteOther = false" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="village_complete_building">
              We are building or have plans for new homes
            </label>
          </li>
          <li class="radio-custom radio-custom--white">
            <Field type="radio" id="village_complete_unsure" name="villageComplete" value="Unsure at this stage" @change="showVillageCompleteOther = false" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="village_complete_unsure">
              Unsure at this stage
            </label>
          </li>
          <li class="radio-custom radio-custom--white">
            <Field type="radio" id="village_complete_other_radio" name="villageComplete" value="Other" @change="showVillageCompleteOther = true" />
            <label class="form-check-label color-very-dark-grayish-blue font-weight-bold" for="village_complete_other_radio">
              Other
            </label>
          </li>
          <li v-if="showVillageCompleteOther" class="d-block">
            <div class="form-group" >
              <label for="village_complete_other" class="sr-only">Village complete other</label>
              <Field
                id="village_complete_other"
                placeholder="Please provide details e.g. care home currently under development"
                type="text"
                class="form-control form-control--bg-white ph-14 fs-14"
                name="village_complete_other"
                :class="{'is-danger': errors['village_complete_other'] }"
              />
              <ErrorMessage name="village_complete_other" class="is-danger" as="span">
                This field is required
              </ErrorMessage>
            </div>
          </li>
        </ul>
        <ErrorMessage name="villageComplete" class="is-danger" as="span">
          This field is required
        </ErrorMessage>
        <hr class="hr-iron mt-4 mb-4">
        <div class="form-group form-group--input">
          <label for="villageName" class="sr-only">Village name</label>
          <Field
            id="villageName"
            placeholder="Village name *"
            type="text"
            class="form-control form-control--bg-white ph-14 fs-14"
            name="villageName"
            :class="{'is-danger': errors['villageName'] }"
          />
          <ErrorMessage name="villageName" class="is-danger" />
        </div>
        <div class="form-group form-group--input">
          <label for="email" class="sr-only">Email</label>
          <Field
            id="email"
            placeholder="Email *"
            type="email"
            class="form-control form-control--bg-white ph-14 fs-14"
            name="email"
            :class="{'is-danger': errors['email'] }"
          />
          <ErrorMessage name="email" class="is-danger" />
        </div>
        <hr class="hr-iron mt-4 mb-4">

        <input type="hidden" name="captcha_action" value="village_enquiry">
        <input type="submit" value="Submit" class="btn btn--green w-100 submit">
        <span class="d-block is-danger mt-2 mb-2" v-if="showErrorMsg" v-cloak>Please complete all fields</span>
        <slot name="googlerecaptchatext"></slot>
      </div>
      <transition name="fade">
        <div class="message-success-full-height" v-if="showSuccessMessage" v-cloak>
          <div class="slider-form__success-round"><i class="icon icon--tick"></i></div>
          <h3 class="slider-form__header fs-20 mt-8 ml-auto mr-auto" style="width: 300px">Thank you, your responses were submitted successfully.</h3>
        </div>
      </transition>
    </Form>
  </div>
</template>

<script setup>
import {computed, reactive, ref, watch} from 'vue'
import axios from 'axios';
import {ErrorMessage, Field, Form} from 'vee-validate'
import {forEach} from "lodash";
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()
const props = defineProps({
  postUrl: {
    type: String,
    default: '',
  },
})

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)
let showSuccessMessage = ref(false)
const showErrorMsg = ref(false)

// const schema = {
//   typeOfHomes: 'required',
//   age: 'required',
//   villageComplete: 'required',
//   village_complete_other: 'required',
//   villageName: 'required',
//   email: 'required|email',
// }

const validationSchema = computed(() => {
  let schema = {
    typeOfHomes: 'required',
    age: 'required',
    villageComplete: 'required',
    email: 'required|email',
    villageName: 'required',
  }

  if (showVillageCompleteOther.value) {
    schema.village_complete_other = 'required'
  }

  if (typeOfHomes.value.length > 0) {
    forEach(typeOfHomes.value, (type) => {
      typeOfHomeOptions.find((item) => {
        if (item.value === type) {
          type = item.name
        }
      })
      schema[`${type}_price`] = 'required'
    })
  }
  return schema
})

const showVillageCompleteOther = ref(false)
const typeOfHomes = ref([])
const typeOfHomeOptions = [
  {
    'name': 'villas',
    'value': 'Villas',
  },
  {
    'name': 'townhouses',
    'value': 'Townhouses',
    'icon': 'icon-tick',
  },
  {
    'name': 'apartments',
    'value': 'Apartments',
  },
  {
    'name': 'serviced_apartments',
    'value': 'Serviced apartments',
  },
  {
    'name': 'other',
    'value': 'Other',
  }
]
const price = ref({})

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('facilityVillageForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post(props.postUrl, formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      let currentUrl = window.location.href;
      history.pushState(null, null, `${currentUrl}#form-completed`);
      showSuccessMessage.value = true;
      setTimeout(function () {
        confirmation.show = false;
      }, 4000);
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}

const isCheckboxChecked = (value, inputModalName) => {
  return (typeOfHomes.value.indexOf(value) !== -1);
}

const rewritePriceValue = (option) => {
  console.log(price.value[option])
  if (price.value[option] !== '' && price.value[option] !== '$' && price.value[option] !== undefined) {
    if (price.value[option].length > 1) {
      console.log(price.value[option], `$${price.value[option]}`)
      price.value[option] = `$${price.value[option].substring(1)}`;
    } else {
      price.value[option] = `$${price.value[option]}`;
    }
  }
  return price.value[option];
}

// import VeeValidate from 'vee-validate';
// import Vue from 'vue';
// import axios from 'axios';
//
// Vue.use(VeeValidate);
//
// export default {
//   data() {
//     return {
//       showSuccessMessage: false,
//       showVillageCompleteOther: false,
//       typeOfHomes: [],
//       typeOfHomeOptions: [
//         {
//           'name': 'villas',
//           'value': 'Villas',
//         },
//         {
//           'name': 'townhouses',
//           'value': 'Townhouses',
//           'icon': 'icon-tick',
//         },
//         {
//           'name': 'apartments',
//           'value': 'Apartments',
//         },
//         {
//           'name': 'serviced_apartments',
//           'value': 'Serviced apartments',
//         },
//         {
//           'name': 'other',
//           'value': 'Other',
//         }
//       ],
//       price: {},
//       showErrorMsg: false,
//     }
//   },
//   methods: {
//     rewritePriceValue(option) {
//       if (this.price[option] !== '' && this.price[option] !== '$') {
//         if (this.price[option].length > 1) {
//           this.price[option] = `$${this.price[option].substring(1)}`;
//         } else {
//           this.price[option] = `$${this.price[option]}`;
//         }
//       }
//       return this.price[option];
//     },
//     isCheckboxChecked(value, inputModalName) {
//       return (this[inputModalName].indexOf(value) !== -1);
//     },
//     validateBeforeSubmit(e) {
//       const vue = this;
//       this.$validator.validateAll().then((result) => {
//         if (result) {
//           this.showErrorMsg = false;
//           let formData = new FormData(e.target);
//           window.grecaptcha.execute(this.$parent.mySiteKeyVariable, {
//             action: formData.get('captcha_action'),
//           }).then((token) => {
//             formData.set('g-recaptcha-response', token);
//             axios.post(e.target.action, formData).then(function (response) {
//               document.getElementById('facilityVillageWrapper').style.display = 'none';
//               vue.showSuccessMessage = true;
//             });
//           });
//         } else {
//           this.showErrorMsg = true;
//         }
//       });
//     },
//   }
// };
</script>
